import React from "react";
import { createRoot } from "react-dom/client";
import LiabilityForm from "./liability-form";

import "../view.css";

document.addEventListener("DOMContentLoaded", function () {
	const element = document.getElementById("react-app");
	if (!element) {
		return;
	}
	const root = createRoot(element);
	root.render(<LiabilityForm />);
});
